import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 cursor-pointer group mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </span>
                <span className="font-heading text-lg font-bold text-foreground-50 whitespace-nowrap">
                  神马影院
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                高清电影在线观看平台，提供海量电影电视剧资源。即点即播，流畅不卡顿。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">全部影片</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-50 mb-4">热门分类</h4>
              <ul className="space-y-2">
                <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">动作片</Link></li>
                <li><Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">喜剧片</Link></li>
                <li><Link to="/category/scifi" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">科幻片</Link></li>
                <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">爱情片</Link></li>
                <li><Link to="/category/animation" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">动画片</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-50 mb-4">联系我们</h4>
              <ul className="space-y-2 text-sm text-foreground-400">
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line"></i></span>
                  service@shenmayingyuan.com
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
                  北京市朝阳区
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-line"></i></span>
                  400-888-8888
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 神马影院 版权所有 | 高清电影在线观看平台
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="/about" className="hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="/about" className="hover:text-primary-400 transition-colors">服务条款</a>
              <a href="/about" className="hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}